module.exports = __webpack_public_path__ + "static/media/bills-page-bg.3ad51abe.svg";